import { Box, styled, Typography } from "@mui/material";

export const StyledModalBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 560,
  maxWidth: "calc(100vw - 32px)",
  background: theme.palette.custom.white,
  borderRadius: theme.borderRadius.radius.large,
  outline: "none",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  [theme.breakpoints.down("sm")]: {
    width: "calc(100vw - 24px)",
  },
}));

export const StyledModalHeader = styled(Box)(({ theme }) => ({
  background: theme.palette.custom.primary,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "13px 20px",
  flexShrink: 0,
}));

export const StyledModalTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.white,
  fontSize: theme.typography.large.fontSize,
  fontWeight: theme.typography.fontWeight.semiBold,
}));

export const StyledModalBody = styled(Box)(() => ({
  padding: "24px",
}));

export const StyledModalMessage = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.lockerValueColor,
  fontSize: theme.typography.base.fontSize,
  lineHeight: 1.6,
}));

export const StyledModalFooter = styled(Box)(() => ({
  display: "flex",
  justifyContent: "flex-end",
  gap: 10,
  padding: "0 24px 24px",
  flexShrink: 0,
}));
